import React from 'react';

import { InformationIcon } from 'assets/icons';
import { colors } from 'themes/foundations/colors';

const CancellationPolicyUpdateAlert: React.FC = () => {
  return (
    <div className="alert alert-warning text-start my-4">
      <InformationIcon
        fill={colors.primary}
        style={{ display: 'inline-block', marginRight: '8px' }}
      />
      <span className="fw-bold mb-1">
        Cancellation Policy Update:
      </span>
      <div>
        Starting 3 August 2026, cancellation penalties may apply when cancelling a booked Jodder on an active job.
      </div>

      <ul className="mb-0 mt-2 ps-3">
        <li>Cancellations made more than 24 hours before the shift start incur no penalty.</li>
        <li>
          Cancellations made within 24 hours before the shift start incur a penalty equivalent to
          {' '}
          <strong>2× the hourly rate</strong>.
        </li>
        <li>
          Cancellations made after the shift has started incur a penalty equivalent to
          {' '}
          <strong>4× the hourly rate</strong>.
        </li>
      </ul>
    </div>
  );
};

export { CancellationPolicyUpdateAlert };
export default CancellationPolicyUpdateAlert;
